import { createApiCall } from "services/api/createApiCall";
import { transformErrorResponse } from "services/api/transformation";
import { InvoiceExtractionSettings, InvoiceExtractionSettingsFormValues } from "./types";
import { transformInvoiceExtractionSettings } from "./transformation";

/*---------------------------------------------------------------------------------------
  INVOICE EXTRACTION SETTINGS - GET
-----------------------------------------------------------------------------------------*/
export const getInvoiceExtractionSettingsAPI = async (): Promise<InvoiceExtractionSettings> => {
  const response = await createApiCall(
    {
      path: "/v1/settings/invoice-extraction",
      method: "GET",
    },
    {
      getMessage: {
        error: (error: any) => `${transformErrorResponse(error)}`,
      },
    }
  )();

  return transformInvoiceExtractionSettings(response.data);
};

/*---------------------------------------------------------------------------------------
  INVOICE EXTRACTION SETTINGS - UPDATE
-----------------------------------------------------------------------------------------*/
export const updateInvoiceExtractionSettingsAPI = async (
  formValues: InvoiceExtractionSettingsFormValues,
  t: (key: string) => string
): Promise<InvoiceExtractionSettings> => {
  const response = await createApiCall(
    {
      path: "/v1/settings/invoice-extraction",
      method: "PUT",
      body: {
        pipeline: formValues.pipeline,
        model: formValues.model,
        ocrModel: formValues.ocrModel,
        prompt: formValues.prompt,
        googleProjectId: formValues.googleProjectId,
        googleProcessorId: formValues.googleProcessorId,
        googleLocation: formValues.googleLocation,
        // Prazno polje znači da spremljeni ključ ostaje — zato se ne šalje.
        googleCredentialsJson: formValues.googleCredentialsJson || undefined,
      },
    },
    {
      getMessage: {
        success: () => "Postavke čitanja računa su spremljene",
        error: (error: any) => `${transformErrorResponse(error)}`,
      },
    }
  )();

  return transformInvoiceExtractionSettings(response.data);
};
